import React, {useState, useEffect} from 'react';
import {Menu} from 'antd';
import {GlobalOutlined, FolderOpenOutlined, SettingOutlined} from '@ant-design/icons';
import {Link} from 'react-router-dom';
import {requestPOST} from 'src/utils/baseAPI';
import './SiderStyle.css';
const {SubMenu} = Menu;

const SiderPage = ({setPathAbsolute}) => {
  const [openKeys, setOpenKeys] = useState(['sub1']);
  const [dataFolderClients, setDataFolderClients] = useState(null);
  const [dataFolderServer, setDataFolderServer] = useState(null);
  const [dataFolderModels, setDataFolderModels] = useState(null);

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const onClickItem = ({item, key, keyPath, domEvent}) => {
    console.log(item);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await requestPOST(`api/v1/downloads/getfolder`, {path: ''});
        if (res) {
          setDataFolderClients(res);
        }
      } catch (error) {}
    };

    fetchData();

    return () => {};
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await requestPOST(`api/v1/downloads/getfolder`, {
          path: 'C:\\ci-cd\\TDParking\\server',
        });
        if (res) {
          setDataFolderServer(res);
        }
      } catch (error) {}
    };

    fetchData();

    return () => {};
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await requestPOST(`api/v1/downloads/getfolder`, {
          path: 'C:\\ci-cd\\TDParking\\models',
        });
        if (res) {
          setDataFolderModels(res);
        }
      } catch (error) {}
    };

    fetchData();

    return () => {};
  }, []);

  return (
    <>
      <div class='col-md-12' style={{margin: '10px'}}>
        <h3 class='animate-charcter'>MEGA PARKING</h3>
      </div>
      <Menu
        mode='inline'
        defaultOpenKeys={openKeys}
        onOpenChange={onOpenChange}
        style={{
          width: '100%',
          background: 'transparent',
        }}
      >
        <SubMenu
          key='sub1'
          icon={<FolderOpenOutlined />}
          title='Phần mềm'
          style={{
            background: 'transparent',
          }}
        >
          {dataFolderClients &&
            dataFolderClients.map((item, index) => (
              <Menu.Item
                key={index}
                style={{
                  background: 'transparent',
                }}
              >
                <Link
                  to={`client/${item?.name}`}
                  onClick={() => setPathAbsolute(item?.path)}
                  className='nav-link'
                >
                  {item?.name}
                </Link>
              </Menu.Item>
            ))}
        </SubMenu>

        <SubMenu key='sub4' icon={<GlobalOutlined />} title='Server'>
          {dataFolderServer &&
            dataFolderServer.map((item) => (
              <Menu.Item key={item?.name}>
                <Link
                  to={`server/${item?.name}`}
                  onClick={() => setPathAbsolute(item?.path)}
                  className='nav-link'
                >
                  {item?.name}
                </Link>
              </Menu.Item>
            ))}
        </SubMenu>

        {/* <SubMenu
          key='1111'
          icon={<FolderOpenOutlined />}
          title='Kiểm thử'
          style={{
            background: 'transparent',
          }}
        >
          {dataFolderClients &&
            dataFolderClients.map((item, index) => (
              <Menu.Item
                key={index}
                style={{
                  background: 'transparent',
                }}
              >
                <Link
                  to={`test/${item?.name}`}
                  onClick={() => setPathAbsolute(item?.path)}
                  className='nav-link'
                >
                  {item?.name}
                </Link>
              </Menu.Item>
            ))}
        </SubMenu> */}

        <SubMenu key='sub5' icon={<FolderOpenOutlined />} title='Phần mềm Kiểm thử'>
          {dataFolderClients &&
            dataFolderClients.map((item) => (
              <Menu.Item key={item?.name}>
                <Link
                  to={`test/${item?.name}`}
                  onClick={() => setPathAbsolute(item?.path)}
                  className='nav-link'
                >
                  {item?.name}
                </Link>
              </Menu.Item>
            ))}
        </SubMenu>

        <SubMenu
          key='sub6'
          icon={<FolderOpenOutlined />}
          title='Mô hình trí tuệ nhân tạo nhận diện biển số'
        >
          {dataFolderModels &&
            dataFolderModels.map((item) => (
              <Menu.Item key={item?.name}>
                <Link
                  to={`model/${item?.name}`}
                  onClick={() => setPathAbsolute(item?.path)}
                  className='nav-link'
                >
                  {item?.name}
                </Link>
              </Menu.Item>
            ))}
        </SubMenu>
      </Menu>
    </>
  );
};

export default SiderPage;
